{
  "_meta.name": "English",
  "_meta.dir": "ltr",
  "app.title": "CenterOS Agent V2",
  "boot.loading": "Signing in…",
  "boot.failed": "Could not sign in",
  "nav.agents": "AI Agents",
  "nav.studio": "Studio",
  "nav.assets": "Assets",
  "nav.tests": "Tests & Scorecard",
  "nav.conversations": "Conversations",
  "nav.telephony": "Phone numbers",
  "nav.usage": "Usage",
  "nav.soon": "soon",
  "agents.title": "AI Agents",
  "agents.empty": "No agents yet. Create your first agent with Studio.",
  "agents.new": "New agent with AI",
  "agents.col.name": "Agent",
  "agents.col.direction": "Direction",
  "agents.col.status": "Status",
  "direction.outbound": "Outbound",
  "direction.inbound": "Inbound",
  "direction.both": "Inbound + outbound",
  "status.draft": "Draft",
  "status.published": "Live",
  "status.archived": "Archived",
  "studio.title": "Studio",
  "studio.subtitle": "Build your agent by chatting. Your Business Brain is ready.",
  "studio.start": "Start new session",
  "studio.starting": "Reading Business Brain…",
  "studio.placeholder": "Type your answer…",
  "studio.send": "Send",
  "studio.thinking": "Thinking…",
  "studio.draft": "Draft",
  "studio.missing": "Missing",
  "studio.filled": "Done",
  "studio.progress": "{done}/{total} fields",
  "studio.propose": "Review draft",
  "studio.approve": "Approve and create agent",
  "studio.approved": "Agent created. Next step: sales assets.",
  "studio.review": "Review",
  "error.generic": "Something went wrong",
  "error.UNAUTHENTICATED": "Session expired, please sign in again.",
  "error.HOST_IDENTITY_MISSING": "Your Panaryus account is not linked to this workspace.",
  "error.BRAIN_NOT_FOUND": "No published business knowledge base was found.",
  "error.STUDIO_INCOMPLETE": "Complete the missing fields first.",
  "error.STUDIO_LLM_BAD_OUTPUT": "The assistant could not respond, try again.",
  "error.STUDIO_INVALID_VALUES": "Some values were unclear, could you be more specific?",
  "field.identity.name": "Agent name",
  "field.identity.brandName": "Brand",
  "field.identity.persona": "Persona",
  "field.languages.primary": "Language",
  "field.direction": "Call direction",
  "field.mission.goal": "Call goal",
  "field.mission.successCondition": "Success criterion",
  "field.mission.audience": "Audience",
  "field.facts": "Information to collect",
  "field.style.tone": "Tone",
  "field.compliance.require[recording_notice].instruction": "Recording notice",
  "field.compliance.require[ai_disclosure].instruction": "AI disclosure",
  "field.globalIntents[opt_out].description": "Do-not-call request",
  "agent.back": "← Agents",
  "agent.tab.assets": "Assets",
  "agent.kit.none": "No sales kit for this agent yet.",
  "agent.kit.build": "Build sales kit",
  "agent.kit.rebuild": "Rebuild kit",
  "agent.kit.building": "Preparing the kit… (about a minute)",
  "agent.kit.failed": "Kit could not be built",
  "agent.kit.version": "Version {v} · {lang}",
  "agent.kit.report": "{generated} lines generated · {repaired} repaired · {dropped} removed",
  "kit.angles": "Value angles",
  "kit.angles.hint": "Ready pitches to approach the customer from different sides",
  "kit.pitch": "Pitch",
  "kit.proof": "Proof",
  "kit.question": "Question",
  "kit.objections": "Objection cards",
  "kit.objection.back": "Return question",
  "kit.discovery": "Discovery questions",
  "kit.closings": "Closing moves",
  "kit.bridges": "Bridge phrases",
  "kit.fallbacks": "Fallback lines",
  "kit.fallback.silence": "On silence",
  "kit.fallback.notUnderstood": "When not understood",
  "kit.fallback.technical": "On technical issue",
  "license.licensed": "Verified by knowledge",
  "license.not_required": "No claim",
  "license.conversational": "Conversational",
  "edit": "Edit",
  "save": "Save",
  "cancel": "Cancel",
  "saving": "Verifying…",
  "error.KIT_LINE_UNLICENSED": "This line could not be verified against your Business Brain. To add a new fact, add it to the Business Brain first.",
  "reason.UNSUPPORTED_NUMBER": "Its number does not appear in the Business Brain.",
  "reason.UNSUPPORTED_CLAIM": "It states something about the business that is not in the Business Brain.",
  "reason.BRIDGE_HAS_CLAIM": "Bridge phrases cannot contain facts.",
  "error.AGENT_NOT_FOUND": "Agent not found.",
  "error.KIT_INSUFFICIENT_ANGLES": "Not enough verified value angles. Add product/service facts to the Business Brain and retry.",
  "error.JOB_INTERRUPTED": "The job was interrupted, please retry.",
  "agent.tab.preview": "Preview",
  "preview.hint": "Try the agent by chatting. You write as the customer; the agent answers as on the phone. No phone rings.",
  "preview.start": "Start preview",
  "preview.restart": "Restart",
  "preview.ended": "The agent ended the call.",
  "preview.turn": "This turn",
  "preview.angle": "Angle",
  "preview.move": "Move",
  "preview.mood": "Customer",
  "preview.facts": "Collected facts",
  "preview.angles": "Angles tried",
  "preview.critics": "Critics",
  "preview.ms": "Time",
  "preview.bridge": "Bridge",
  "preview.none": "—",
  "preview.needKit": "Build the sales kit first to preview.",
  "error.AGENT_NOT_READY": "Build the sales kit first to preview.",
  "error.PREVIEW_NOT_FOUND": "Preview expired, restart it.",
  "agent.tab.tests": "Tests & Scorecard",
  "score.hint": "The agent talks, without a phone, to simulated impatient, rude, skeptical, refusing, confused and competitor-happy customers; every conversation is scored. An agent cannot go live until the scorecard passes.",
  "score.run": "Run scorecard",
  "score.running": "Scorecard running… (a few minutes)",
  "score.none": "No scorecard yet.",
  "score.pass": "Passed the gate",
  "score.fail": "Did not pass",
  "score.failures": "Below threshold",
  "metric.naturalness": "Naturalness",
  "metric.intent": "Intent",
  "metric.respect": "Respect",
  "metric.persuasion": "Persuasion",
  "metric.questionRate": "Question rate",
  "metric.factCoverage": "Facts collected",
  "metric.nextStepRate": "Next step",
  "metric.repeats": "Repeats",
  "metric.silentTurns": "Silent turns",
  "metric.identityRepeats": "Identity repeats",
  "statements.title": "Business answers",
  "statements.hint": "Your business's own answers to questions customers often ask. The agent uses them when the topic comes up; what you write here is treated as verified.",
  "statements.contactSource": "Answer to \"where did you get my number?\"",
  "statements.contactSource.placeholder": "E.g. Your contact details come from a public business directory.",
  "statements.topic": "Topic (e.g. pricing)",
  "statements.answer": "Answer",
  "statements.add": "Add answer",
  "statements.remove": "Remove",
  "statements.saved": "Saved",
  "error.CONTACT_SOURCE_STATEMENT_REQUIRED": "Agents that place calls need an answer to \"where did you get my number\".",
  "error.SPEC_INVALID": "Answers are invalid (a topic may appear twice).",
  "humor.title": "Tone for unknown questions",
  "humor.hint": "When the agent cannot answer a question it says so honestly, then moves the call on. With light humor it does this with a small, warm touch.",
  "humor.light": "Light humor (recommended)",
  "humor.off": "No humor, plain",
  "kit.plain": "Plain explanations",
  "kit.plain.hint": "Short, jargon-free explanations the agent uses when the customer does not understand.",
  "agent.publish": "Publish",
  "agent.publish.running": "Publishing…",
  "agent.publish.hint": "Current settings and sales kit are saved as an immutable version; real calls only use the published version.",
  "agent.publish.version": "live version",
  "agent.publish.done": "Published (version {{id}}). Real calls now use this version.",
  "error.KIT_MISSING_FOR_LANGUAGE": "A sales kit is needed for every language before publishing.",
  "error.AGENT_NOT_PUBLISHED": "The agent is not published yet.",
  "calls.title": "Calls · listen and follow up",
  "calls.subtitle": "Calls made by your agents, with recordings and outcomes.",
  "calls.tab.all": "All calls",
  "calls.tab.callbacks": "Callbacks",
  "calls.tab.dnc": "Do not call",
  "calls.col.date": "Date",
  "calls.col.number": "Number",
  "calls.col.agent": "Agent",
  "calls.col.duration": "Duration",
  "calls.col.result": "Result",
  "calls.col.callbackWhen": "When",
  "calls.col.note": "Note",
  "calls.empty": "No calls yet. Start the first one with “Call” on an agent's page.",
  "calls.callbacks.empty": "No callbacks waiting.",
  "calls.callbacks.done": "Done",
  "calls.hasRecording": "Recording available",
  "calls.result.machine": "Voicemail",
  "calls.result.optedOut": "Asked not to be called",
  "calls.result.callback": "Callback: {when}",
  "calls.result.live": "In progress",
  "calls.result.notAnswered": "Not answered",
  "calls.result.error": "Technical error",
  "calls.result.talked": "Talked",
  "calls.back": "Conversations",
  "calls.recording": "Recording",
  "calls.noRecording": "This call has no recording.",
  "calls.recordingTruncated": "The recording was shortened by the length limit.",
  "calls.transcript": "Conversation",
  "calls.noTurns": "No transcript.",
  "calls.event.silent": "The customer stayed silent",
  "calls.callback": "Callback",
  "calls.callback.open": "Not called yet",
  "calls.callback.doneAt": "Called: {at}",
  "calls.facts": "Collected information",
  "calls.noFacts": "Nothing collected.",
  "dnc.hint": "No agent calls these numbers. When a customer says “don't call me”, the number is added here automatically.",
  "dnc.placeholder": "+1 555 000 0000",
  "dnc.add": "Add to list",
  "dnc.remove": "Remove",
  "dnc.empty": "The list is empty.",
  "dnc.col.reason": "Reason",
  "dnc.reason.opt_out": "Customer asked",
  "dnc.reason.manual": "Added manually",
  "call.start": "Call",
  "call.placeholder": "Type a number, name or company",
  "call.next": "Continue",
  "call.confirm": "{phone} will be called now. The call is billed per minute. Confirm?",
  "call.yes": "Yes, call",
  "call.dialing": "Calling…",
  "call.started": "The call has started.",
  "call.openCall": "Open the call",
  "common.yes": "Yes",
  "common.no": "No",
  "common.cancel": "Cancel",
  "common.back": "Back",
  "error.CALL_NOT_FOUND": "Call not found.",
  "error.RECORDING_NOT_FOUND": "Recording not found.",
  "error.CALLBACK_NOT_FOUND": "This call has no open callback.",
  "error.PHONE_NOT_E164": "Write the number with its country code (e.g. +1 555 …).",
  "error.DO_NOT_CALL": "This number is on the do-not-call list.",
  "error.OUTBOUND_DISABLED": "Outbound calling is not enabled on this installation.",
  "error.HISTORY_NOT_CONFIGURED": "Call history is not enabled on this installation.",
  "error.DO_NOT_CALL_NOT_CONFIGURED": "The do-not-call list is not enabled on this installation.",
  "calls.col.callbackState": "Status",
  "callback.state.scheduled": "Agent will call: {at}",
  "callback.state.dialed": "Agent called",
  "callback.state.expired": "Missed, not called",
  "callback.state.notCalled": "Not called: {reason}",
  "callback.state.manual": "Team will call",
  "callback.openCall": "Open the callback call",
  "callback.fromCall": "← This is the callback promised in an earlier call",
  "error.BILLING_PRINCIPAL_MISSING": "No account to bill.",
  "error.VOICE_MINUTES_EXCEEDED": "No call minutes left.",
  "error.ORIGINATE_FAILED": "The line could not be opened.",
  "ambience.title": "Background sound",
  "ambience.hint": "A soft room sound behind the call; it dips while the agent speaks.",
  "ambience.bed.none": "None",
  "ambience.bed.office": "Office",
  "ambience.level": "Level",
  "ambience.save": "Save",
  "ambience.saved": "Saved — publish to use it in calls.",
  "error.DONE_BY_TEAM": "Handled by the team (automatic call cancelled)",
  "agent.tab.general": "General",
  "agent.tab.voice": "Voice",
  "agent.tab.knowledge": "Knowledge",
  "agent.tab.kit": "Sales kit",
  "agent.tab.compliance": "Compliance",
  "agent.tab.test": "Test",
  "draft.differs": "There are changes not yet live (live: version {live}, draft: version {draft}). Publish to use them in calls.",
  "draft.notPublished": "This agent is not published yet; real calls use the published version.",
  "settings.identity": "Identity",
  "settings.mission": "Mission",
  "settings.maxSentences": "Max sentences per answer",
  "settings.maxSentences.hint": "2 is recommended on the phone.",
  "settings.facts.hint": "What the agent tries to learn in the call. Shown in Conversations after the call.",
  "settings.facts.label": "Information",
  "settings.facts.type": "Type",
  "settings.facts.required": "Required",
  "settings.facts.add": "Add information",
  "settings.facts.enumPlaceholder": "Options, comma separated (e.g. signup, callback)",
  "settings.factType.text": "Text",
  "settings.factType.boolean": "Yes/No",
  "settings.factType.number": "Number",
  "settings.factType.enum": "Choice",
  "settings.factType.datetime": "Date-time",
  "settings.factType.phone": "Phone",
  "settings.factType.email": "Email",
  "settings.remove": "Remove",
  "settings.save": "Save",
  "settings.saving": "Saving…",
  "settings.saved": "Saved — publish to use it in calls.",
  "settings.compliance": "Must be said",
  "settings.compliance.hint": "The agent always says these at the start of the call.",
  "settings.boundaries": "Boundaries",
  "settings.blockedTopics": "Topics never discussed",
  "settings.mustNotPromise": "Never promised",
  "settings.onePerLine": "One per line.",
  "assist.title": "Tell the AI",
  "assist.hint": "Write what should change in your own words; you see the proposed change and it is saved when you apply it.",
  "assist.placeholder": "E.g. Be warmer and keep answers short",
  "assist.ask": "Propose",
  "assist.thinking": "Thinking…",
  "assist.proposal": "Proposed change",
  "assist.noChange": "No change proposed.",
  "assist.apply": "Apply",
  "field.style.maxSentencesPerTurn": "Max sentences per answer",
  "field.style.maxQuestionsPerTurn": "Max questions per answer",
  "field.style.humor": "Humor",
  "field.boundaries.blockedTopics": "Topics never discussed",
  "field.boundaries.mustNotPromise": "Never promised",
  "field.timezone": "Time zone",
  "field.compliance.require": "Must be said",
  "field.globalIntents": "Intents",
  "field.statements": "Business answers",
  "field.ambience": "Background sound",
  "error.SPEC_FIELD_LOCKED": "This field cannot be changed here.",
  "error.SPEC_ASSIST_BAD_OUTPUT": "The AI could not produce a valid proposal; rephrase and try again.",
  "error.VALIDATION_FAILED": "Some fields are missing or invalid.",
  "voice.title": "Agent voice",
  "voice.hint": "Each voice reads your agent's own line. Listen and pick one; after saving and publishing, calls use this voice.",
  "voice.filter.all": "All",
  "voice.filter.female": "Female",
  "voice.filter.male": "Male",
  "voice.gender.female": "Female",
  "voice.gender.male": "Male",
  "voice.speed": "Speaking speed",
  "voice.listen": "Listen",
  "voice.stop": "Stop",
  "voice.loading": "Preparing…",
  "voice.default": "No voice chosen yet; the platform default voice is used.",
  "error.VOICES_NOT_CONFIGURED": "The voice catalogue is not enabled on this installation.",
  "error.VOICES_UNAVAILABLE": "The voice list is not available right now.",
  "error.VOICE_SAMPLE_FAILED": "The sample could not be made.",
  "field.voice": "Voice",
  "agent.back.short": "Agents",
  "agent.status.live": "Live",
  "agent.status.changed": "Unpublished changes",
  "agent.status.draft": "Not published",
  "agent.liveVersion": "live version {v}",
  "agent.draftVersion": "draft version {v}",
  "agent.publish.upToDate": "Up to date",
  "settings.identity.hint": "The name the agent introduces itself with and the brand it represents.",
  "settings.personality": "Personality and style",
  "settings.personality.hint": "How it sounds as a person. Short, clear answers sound more natural on the phone.",
  "settings.mission.hint": "Why the call is made, what counts as success and who is on the line. The agent chooses every answer by this.",
  "settings.boundaries.hint": "Topics the agent never raises and promises it never makes.",
  "settings.unsaved": "You have unsaved changes",
  "settings.discard": "Discard",
  "common.sure": "Sure?",
  "voice.search": "Search voices",
  "voice.own": "Your voice",
  "voice.chosen": "Selected",
  "voice.speed.hint": "1.00 is normal speed. Slightly slower (0.95) can be clearer on the phone.",
  "voice.age.young": "Young",
  "voice.age.middle_aged": "Middle-aged",
  "voice.age.middle aged": "Middle-aged",
  "voice.age.old": "Mature",
  "voice.accent.american": "American accent",
  "voice.accent.british": "British accent",
  "voice.accent.australian": "Australian accent",
  "voice.accent.irish": "Irish accent",
  "voice.accent.turkish": "Turkish",
  "voice.accent.standard": "Standard",
  "ambience.bed.none.hint": "No background sound.",
  "ambience.bed.office.hint": "A soft office room; it dips while the agent speaks.",
  "knowledge.source.label": "Answer",
  "knowledge.source.hint": "What the agent says when a customer asks “where did you get my number?”.",
  "knowledge.source.hint.required": "What the agent says when a customer asks “where did you get my number?”. Required for agents that place calls.",
  "knowledge.empty": "No business answers yet. Start with a question customers often ask.",
  "knowledge.done": "Done",
  "humor.light.hint": "Says honestly when it does not know, with a small warm touch.",
  "humor.off.hint": "Says it plainly and seriously when it does not know.",
  "calls.search": "Search name, number or agent",
  "calls.prior": "Previous calls: {n}",
  "calls.counterpart.title": "Calls with this number",
  "calls.counterpart.counts": "Total: {total} · Before this one: {before}",
  "calls.counterpart.none": "No other calls with this number.",
  "calls.counterpart.all": "Show all",
  "calls.counterpart.inContacts": "In contacts",
  "calls.counterpart.notInContacts": "Not in contacts",
  "calls.counterpart.name": "Name (optional)",
  "calls.counterpart.add": "Add to contacts",
  "calls.counterpart.addHint": "Only the number and the name you type are saved; the person is not called automatically. A deletion request removes this contact too.",
  "calls.counterpart.added": "Added to contacts.",
  "calls.counterpart.exists": "This number is already in contacts.",
  "calls.filter.sameNumber": "Only calls with this number",
  "calls.filter.clear": "Clear filter",
  "calls.party.none": "No number",
  "calls.kind.all": "All",
  "calls.kind.callback": "Callback",
  "calls.kind.talked": "Talked",
  "calls.kind.machine": "Voicemail",
  "calls.kind.optedOut": "Opted out",
  "voice.gender.neutral": "Neutral",
  "app.subtitle": "Customer operations",
  "app.workspace": "Workspace",
  "nav.group.daily": "Daily work",
  "nav.group.build": "Build",
  "nav.group.setup": "Setup",
  "nav.overview": "Overview",
  "nav.callbacks": "Callbacks",
  "nav.campaigns": "Campaigns",
  "nav.leads": "Leads",
  "nav.doNotCall": "Do not call",
  "nav.agent": "AI Agents",
  "nav.calls": "Conversations",
  "nav.call": "Conversations",
  "theme.label": "Theme",
  "theme.dark": "Dark",
  "theme.light": "Light",
  "overview.badge": "TODAY",
  "overview.strip": "What happened today and what comes next — all here.",
  "overview.refresh": "Refresh",
  "overview.queue.kicker": "Live queue",
  "overview.queue.title": "What needs attention",
  "overview.kpi.today": "Calls today",
  "overview.kpi.talked": "Talked",
  "overview.kpi.callbacks": "Callbacks waiting",
  "overview.kpi.machine": "Voicemail",
  "overview.kpi.avg": "Average call",
  "overview.kpi.agents": "Live agents",
  "overview.att.noAgent": "No live agent",
  "overview.att.noAgent.body": "Publish an agent to place calls.",
  "overview.att.noAgent.cta": "Go to agents",
  "overview.att.manual": "{n} callbacks wait for your team",
  "overview.att.manual.body": "These customers were promised a call; mark them “Done” after calling.",
  "overview.att.callbacks.cta": "Go to callbacks",
  "overview.att.auto": "{n} automatic callbacks scheduled",
  "overview.att.auto.body": "Next: {at} · {agent} will call.",
  "overview.att.changed": "{name}: unpublished changes",
  "overview.att.changed.body": "Settings reach calls only after publishing.",
  "overview.att.changed.cta": "Go to agent",
  "overview.att.errors": "{n} calls ended with a technical error today",
  "overview.att.errors.body": "Check the call records for the cause.",
  "overview.att.errors.cta": "Review calls",
  "overview.att.none": "Nothing is waiting right now",
  "overview.att.none.body": "New calls and callbacks show up here as they come.",
  "overview.command.kicker": "Command center",
  "overview.command.title": "What should I do next?",
  "overview.command.body": "Start calls, listen to conversations, follow up callbacks — home is your work queue.",
  "overview.command.call": "Start a call with {name}",
  "overview.command.create": "Create the first agent",
  "overview.command.review": "Review calls",
  "overview.command.callbacks": "Callbacks",
  "overview.step.create": "Create",
  "overview.step.create.body": "Build your agent with AI in the Studio.",
  "overview.step.publish": "Publish",
  "overview.step.publish.body": "Pick voice and settings, then publish.",
  "overview.step.call": "Call",
  "overview.step.call.body": "Call a number from the agent page.",
  "overview.step.follow": "Follow up",
  "overview.step.follow.body": "Listen to recordings, close callbacks.",
  "overview.recent": "Recent calls",
  "overview.recent.all": "See all",
  "calls.card": "Call card",
  "calls.tile.duration": "Duration",
  "calls.tile.recording": "Recording",
  "calls.tile.turns": "Customer turns",
  "calls.tile.ended": "Ended by",
  "calls.tile.ready": "Ready",
  "calls.endedBy.agent": "Agent",
  "calls.endedBy.caller": "Other side",
  "calls.endedBy.error": "Error",
  "calls.cardTab.summary": "Summary",
  "calls.cardTab.transcript": "Conversation",
  "calls.cardTab.recording": "Recording",
  "calls.recording.hint": "Other side on the left ear, the agent on the right.",
  "calls.list.kicker": "List",
  "calls.list.title": "Call history",
  "calls.kind.today": "Today",
  "calls.kind.recorded": "Recorded",
  "calls.none": "No calls in this filter.",
  "calls.pick": "Pick a call on the left.",
  "agents.subtitle": "Create, tune, publish, then test · {n} agents",
  "agents.path.create": "Create",
  "agents.path.tune": "Tune",
  "agents.path.publish": "Publish",
  "agents.path.test": "Test call",
  "agents.stat.total": "Total agents",
  "agents.stat.outbound": "Outbound",
  "agents.stat.inbound": "Inbound",
  "agents.stat.live": "Live",
  "agents.filter.all": "All",
  "agents.filter.outbound": "Outbound",
  "agents.filter.inbound": "Inbound",
  "agents.filter.live": "Live",
  "agents.filter.draft": "Draft / changes",
  "agents.search": "Search agents",
  "agents.open": "Open",
  "agent.tab.actions": "Actions",
  "actions.callback": "Callback",
  "actions.callback.hint": "Whether the agent may take a time and promise a callback when the customer says “call me later”. With a time zone set, the agent calls at that time itself.",
  "actions.callback.on": "May promise callbacks",
  "actions.callback.on.hint": "Takes the time, records it; the agent calls when it is due.",
  "actions.callback.off": "Never promises callbacks",
  "actions.callback.off.hint": "Offers another next step.",
  "actions.callback.when": "When to offer a callback",
  "actions.callback.when.hint": "The agent offers a callback in these situations; write it in your own words.",
  "actions.callback.defaultDescription": "The customer cannot talk now, wants to speak with the decision maker, or agrees to be called later",
  "actions.timezone": "Time zone",
  "actions.timezone.hint": "Times the customer says, like “tomorrow 10:30”, are understood in this zone.",
  "actions.timezone.none": "Not set",
  "actions.timezone.browser": "Use this device's ({zone})",
  "actions.timezone.needed": "Without a time zone, callbacks are not placed automatically; they go to the team's list.",
  "actions.hours": "Calling hours",
  "actions.hours.hint": "When this agent itself calls out (callbacks, campaigns) and which callback times it may promise. Hours for calls coming in are set per number on the Phone numbers page.",
  "actions.hours.any": "Any time",
  "actions.hours.any.hint": "No time limit.",
  "actions.hours.limited": "Set days and hours",
  "actions.hours.limited.hint": "Choose the time zone first.",
  "actions.hours.start": "Start",
  "actions.hours.end": "End",
  "actions.hours.invalid": "Pick at least one day; the end must be after the start.",
  "day.1": "Mon",
  "day.2": "Tue",
  "day.3": "Wed",
  "day.4": "Thu",
  "day.5": "Fri",
  "day.6": "Sat",
  "day.7": "Sun",
  "field.businessHours": "Business hours",
  "error.OUTSIDE_HOURS": "Outside business hours",
  "actions.hours.limited.ready": "On the chosen days, between the hours you set.",
  "agent.tab.conversation": "Conversation",
  "pace.title": "Conversation pace",
  "pace.hint": "How long the agent waits for the caller: before deciding they finished, before speaking again in a silence, and for the “hello” at the start.",
  "pace.relaxed": "Patient",
  "pace.relaxed.hint": "Waits longer; for callers who think or speak slowly.",
  "pace.normal": "Normal",
  "pace.normal.hint": "Recommended for most calls.",
  "pace.quick": "Quick",
  "pace.quick.hint": "For short, fast-paced calls.",
  "field.pace": "Conversation pace",
  "studio.templates.kicker": "Quick start",
  "studio.templates.title": "Build your agent by chatting",
  "studio.templates.hint": "The AI asks step by step and you answer. To start fast with a ready agent, choose \"Ready agents\".",
  "studio.templates.blank": "Start blank",
  "studio.templates.blank.hint": "The AI builds it with you from the first question.",
  "error.TEMPLATE_NOT_FOUND": "Template not found.",
  "nav.contacts": "Contacts",
  "nav.campaign": "Campaigns",
  "contacts.title": "Contacts",
  "contacts.subtitle": "The people campaigns call · {n} contacts",
  "contacts.import": "Bulk add (Excel / CSV)",
  "contacts.file": "Choose a CSV file",
  "contacts.import.hint": "Copy rows from Excel or Google Sheets and paste them, or choose a CSV file. The phone column is found automatically; if the first row is a header, other columns are kept as extra information. Write numbers with the country code (+…).",
  "contacts.import.placeholder": "Name\tPhone\tCity\nAcme Ltd\t+1 555 000 0001\tBoston",
  "contacts.preview": "{n} rows found · columns: {columns}",
  "contacts.add": "Add {n} contacts",
  "contacts.imported": "{inserted} new contacts added, {updated} updated, {invalid} rows had an invalid number.",
  "contacts.search": "Search name or number",
  "contacts.empty": "No contacts yet. Add some above.",
  "contacts.col.name": "Name",
  "contacts.col.fields": "Extra information",
  "campaigns.title": "Campaigns",
  "campaigns.subtitle": "An agent calling your contacts one by one; unreached ones are retried.",
  "campaigns.new": "New campaign",
  "campaigns.empty": "No campaigns yet.",
  "campaigns.status.draft": "Draft",
  "campaigns.status.running": "Calling",
  "campaigns.status.paused": "Paused",
  "campaigns.status.done": "Done",
  "campaigns.status.cancelled": "Cancelled",
  "campaigns.targets": "{n} contacts",
  "campaigns.stat.total": "Total",
  "campaigns.stat.pending": "Queued",
  "campaigns.stat.dialing": "Calling",
  "campaigns.stat.done": "Talked",
  "campaigns.stat.failed": "Not reached",
  "campaigns.stat.skipped": "Skipped",
  "campaigns.stat.left": "left",
  "campaigns.step.1": "Name and agent",
  "campaigns.step.2": "Contacts",
  "campaigns.step.3": "Settings",
  "campaigns.step.4": "Summary",
  "campaigns.name": "Campaign name",
  "campaigns.name.placeholder": "E.g. October — Boston clinics",
  "campaigns.agent": "Calling agent",
  "campaigns.agent.hint": "Only live agents that place calls are listed.",
  "campaigns.agent.none": "No live agent can place calls; publish one first.",
  "campaigns.contacts.none": "No contacts yet.",
  "campaigns.contacts.go": "Go to contacts",
  "campaigns.picked": "{n} / {total} selected",
  "campaigns.all": "All",
  "campaigns.none": "None",
  "campaigns.concurrency": "Calls at once",
  "campaigns.concurrency.hint": "How many people are called at the same time. Choose by how many calls your line carries; if unsure, 1.",
  "campaigns.attempts": "Attempts",
  "campaigns.attempts.hint": "Calls not answered, reaching voicemail or dropped at once are retried up to this many times.",
  "campaigns.retry": "Retry after",
  "campaigns.minutes": "{n} minutes",
  "campaigns.hours": "{n} hours",
  "campaigns.day": "1 day",
  "campaigns.hours.note": "Calls are made in the agent's business hours (Agent → Actions). Numbers on the do-not-call list are never called.",
  "campaigns.confirm": "{n} people will be called. Every call is billed per minute. Start?",
  "campaigns.confirm.yes": "Yes, start",
  "campaigns.saveDraft": "Save as draft",
  "campaigns.createStart": "Create and start",
  "campaigns.start": "Start",
  "campaigns.resume": "Resume",
  "campaigns.pause": "Pause",
  "campaigns.cancel": "Cancel campaign",
  "campaigns.settings": "{c} at once · {a} attempts · every {r} min",
  "campaigns.col.status": "Status",
  "campaigns.col.attempts": "Attempts",
  "campaigns.target.pending": "Queued",
  "campaigns.target.dialing": "Calling",
  "campaigns.target.done": "Talked",
  "campaigns.target.failed": "Not reached",
  "campaigns.target.skipped": "Skipped",
  "campaigns.result.talked": "Talked",
  "campaigns.result.callback": "Callback",
  "campaigns.result.opted_out": "Asked not to be called",
  "campaigns.result.no_answer": "No answer",
  "campaigns.result.voicemail": "Voicemail",
  "campaigns.result.error": "Technical error",
  "campaigns.result.skipped": "Skipped",
  "campaigns.result.retry": "Will be tried again later",
  "error.CAMPAIGN_FINISHED": "This campaign is finished or cancelled.",
  "error.CAMPAIGN_NOT_FOUND": "Campaign not found.",
  "error.CONTACT_NOT_FOUND": "Contact not found.",
  "leads.title": "Leads",
  "leads.subtitle": "Sales pipeline · {n} contacts · {hot} hot",
  "leads.empty": "No contacts yet. Add contacts and start a campaign; the calls land here.",
  "leads.openCall": "Last call",
  "leads.notCalled": "Not called yet",
  "leads.moveTo": "Move to stage",
  "leads.score.hot": "Hot",
  "leads.score.warm": "Warm",
  "leads.score.cold": "Cold",
  "leads.stage.new": "New",
  "leads.stage.contacted": "Contacted",
  "leads.stage.interested": "Interested",
  "leads.stage.callback": "Callback",
  "leads.stage.won": "Won",
  "leads.stage.lost": "Lost",
  "calls.analysis": "Call summary",
  "calls.nextAction": "Next step:",
  "calls.sentiment.positive": "Positive",
  "calls.sentiment.neutral": "Neutral",
  "calls.sentiment.negative": "Negative",
  "contacts.col.stage": "Stage",
  "contacts.col.kind": "Type",
  "contacts.kind.label": "Number type",
  "contacts.kind.hint": "“Not known” is handled like a person (the careful side).",
  "contacts.kind.business": "Business",
  "contacts.kind.person": "Person",
  "contacts.kind.unknown": "Not known",
  "contacts.kind.all": "All",
  "contacts.kind.header.aliases": "number type|type|kind",
  "contacts.kind.business.aliases": "business|company|corporate|b2b",
  "contacts.kind.person.aliases": "person|individual|private|consumer",
  "contacts.kind.unknown.aliases": "unknown|not known",
  "lines.title": "Phone lines",
  "lines.subtitle": "Connect your own SIP line, choose which agent answers each number and which number each agent calls from.",
  "lines.add": "Add line",
  "lines.edit": "Edit",
  "lines.save": "Save and connect",
  "lines.saved": "Saved.",
  "lines.applied": "Lines applied to the PBX.",
  "lines.notApplied": "Saved, but the PBX could not be updated right now.",
  "lines.retry": "Try again",
  "lines.empty": "No lines yet. Add your first line with the username and password from your SIP provider.",
  "lines.provider.verimor": "Verimor",
  "lines.provider.zadarma": "Zadarma",
  "lines.provider.sip": "Other SIP",
  "lines.provider.verimor.hint": "The username (usually your number) and password under PBX → SIP accounts in the Verimor panel.",
  "lines.provider.zadarma.hint": "The SIP login (e.g. 123456-100) and password under Settings → SIP connection in your Zadarma account.",
  "lines.provider.sip.hint": "The SIP server, username and password from your provider. The line connects by registering.",
  "lines.label": "Line name",
  "lines.label.hint": "For you, e.g. Sales line.",
  "lines.username": "SIP username",
  "lines.username.hint": "The username your provider gave you.",
  "lines.password": "SIP password",
  "lines.password.keep": "Leave empty to keep the current password.",
  "lines.host": "SIP server",
  "lines.port": "Port",
  "lines.authUsername": "Authentication user",
  "lines.authUsername.hint": "Only if your provider gave a separate one.",
  "lines.advanced": "Advanced settings",
  "lines.secretNote": "The password is stored encrypted and never shown again.",
  "lines.system": "System line",
  "lines.state.registered": "Connected",
  "lines.state.rejected": "Username/password rejected",
  "lines.state.unreachable": "Server unreachable",
  "lines.state.pending": "Connecting…",
  "lines.state.unknown": "Status unavailable",
  "lines.unverified": "Inbound calls reach this line's numbers once the line has connected successfully for the first time.",
  "lines.number": "Number",
  "lines.numberLabel": "Description",
  "lines.numberLabel.placeholder": "e.g. Main line",
  "lines.inboundAgent": "Answered by",
  "lines.inbound.none": "Not answered by V2",
  "lines.notPublished": "not published",
  "lines.addNumber": "Add number",
  "lines.numberAdded": "Number added.",
  "lines.outbound.title": "Which number do agents call from?",
  "lines.outbound.hint": "Each agent can call from its own number. Otherwise the platform's default line is used.",
  "lines.agent": "Agent",
  "lines.outbound.number": "Caller number",
  "lines.outbound.default": "Default line",
  "error.SIP_FIELD_INVALID": "A field is invalid. The server must be a lowercase host name or IP; the username must not contain spaces or @; the password cannot contain a backslash (\\).",
  "error.PROVIDER_UNKNOWN": "Unknown provider.",
  "error.NUMBER_TAKEN": "This number belongs to another business on the platform.",
  "error.LINE_NOT_FOUND": "Line not found.",
  "error.NUMBER_NOT_FOUND": "Number not found.",
  "error.TELEPHONY_NOT_CONFIGURED": "Phone lines are not enabled on this installation yet.",
  "numbers.title": "Phone numbers",
  "numbers.subtitle": "Add your business's SIP numbers; choose which agent answers each number and which agents call from it.",
  "numbers.add": "Add number",
  "numbers.step.1": "SIP account",
  "numbers.step.2": "Number",
  "numbers.step.3": "Agents",
  "numbers.newAccount": "Connect a new SIP account",
  "numbers.newAccount.hint": "With the username and password from your provider.",
  "numbers.accountCreated": "SIP account connected. Continue by adding the number.",
  "numbers.e164.hint": "With the country code (+1…). The number then belongs only to your business on the platform.",
  "numbers.inbound": "Answered by",
  "numbers.inbound.hint": "The agent that talks to people calling this number. Only published agents can be chosen.",
  "numbers.outbound": "Agents calling from this number",
  "numbers.outbound.hint": "These agents show this number on outbound calls (single calls, campaigns, callbacks). An agent calls from one number.",
  "numbers.nowUses": "now {number}",
  "numbers.noAgents": "No agents yet.",
  "numbers.back": "Back",
  "numbers.next": "Continue",
  "numbers.finish": "Add number",
  "numbers.added": "Number added and connected to the agents.",
  "numbers.empty": "No numbers yet. Use “Add number” to connect your SIP account and add your first number.",
  "numbers.account": "SIP account",
  "numbers.addCaller": "+ Add agent",
  "numbers.defaultNote": "Agents not connected to a number call from the platform's default line.",
  "numbers.plan": "Opening hours",
  "numbers.plan.always": "Always open",
  "numbers.plan.add": "Set hours",
  "numbers.plan.needAgent": "First choose the agent that answers this number.",
  "numbers.plan.now.open": "Open now",
  "numbers.plan.now.closed": "Closed now",
  "numbers.plan.now.holiday": "Closed today",
  "numbers.plan.after.same": "After hours: same agent",
  "numbers.plan.after.agent": "After hours: {agent}",
  "numbers.plan.after.refuse": "After hours: not answered",
  "plan.title": "Opening hours · {number}",
  "plan.edit": "Edit",
  "plan.scopeNote": "These hours are only for calls coming in to this number. When agents call out (callbacks, campaigns) is set on each agent's Actions tab.",
  "plan.mode.always": "Always",
  "plan.mode.always.hint": "No limit; every call goes to the same agent, as today.",
  "plan.mode.limited": "On set days and hours",
  "plan.timezone.agent": "Use the agent's ({zone})",
  "plan.copyAgent": "Copy the agent's calling hours",
  "plan.day.closed": "Closed",
  "plan.day.allDay": "24 hours",
  "plan.window.add": "+ Second period",
  "plan.window.remove": "Remove period",
  "plan.applyAll": "Apply these hours to all open days",
  "plan.overnight.hint": "For hours past midnight use two days (e.g. 22:00–24:00, then 00:00–02:00 the next day).",
  "plan.closedDates": "Closed dates",
  "plan.closedDates.hint": "Holidays and similar. All numbers count as closed that whole day (each in its own time zone); what happens then is each number's own after-hours setting. Add them again each year.",
  "plan.closedDates.add": "Add",
  "plan.closedDates.empty": "No closed dates.",
  "plan.closedDates.workspaceNote": "Closed dates (holidays) are shared by all numbers; add them in the \"Closed dates\" card at the bottom of the page.",
  "plan.after": "Calls outside these hours",
  "plan.after.same": "The same agent answers",
  "plan.after.same.hint": "As today. The agent does not know it is after hours; no transfer to a person by phone is tried, the agent takes a message.",
  "plan.after.agent": "Another agent answers",
  "plan.after.agent.hint": "For example an agent that only takes messages. What it says, its disclosures included, comes from its own settings. If it cannot answer (not published, no credit) the number's own agent does.",
  "plan.after.agent.pick": "Choose an agent",
  "plan.after.agent.noHours": "This agent has no calling hours of its own: it may place promised callbacks at any hour. Set them in Agent → Actions.",
  "plan.after.agent.noNumber": "This agent calls from none of your numbers; its callbacks use the platform's default number.",
  "plan.after.refuse": "Not answered",
  "plan.after.refuse.hint": "The call does not go to an agent and no call record is made; only the count is kept, never who called. Choose below what the caller hears.",
  "plan.refuse.style": "What does the caller hear?",
  "plan.refuse.ring": "It rings, nobody answers",
  "plan.refuse.ring.hint": "like a closed office; nothing is charged. When it times out the carrier may play its own announcement.",
  "plan.refuse.message": "A closed message is played",
  "plan.refuse.message.hint": "the call is answered, the message below is read in the agent's voice, then it hangs up; line minutes are charged.",
  "plan.refuse.reject": "Rejected at once",
  "plan.refuse.reject.hint": "rejected before it is answered; the carrier plays an announcement such as \"the extension cannot be used\".",
  "plan.refuse.message.placeholder": "For example: We are closed right now. You can reach us on weekdays between 09:00 and 18:00.",
  "plan.refuse.message.note": "Voiced once when saved. {n} characters left.",
  "plan.refuse.message.listen": "Listen to the saved message",
  "plan.refused": "Refused after hours: today {today}, last 7 days {week}",
  "plan.preview": "Now {day} {time} ({zone}): {state}. {answer}",
  "plan.preview.note": "(From the saved plan; changes show after saving.)",
  "plan.state.open": "open",
  "plan.state.closed": "closed",
  "plan.state.holiday": "closed day",
  "plan.answer.agent": "{agent} answers.",
  "plan.answer.nobody": "The call is not answered.",
  "plan.invalid.window": "End must be after start; periods must not overlap.",
  "plan.invalid.empty": "Set hours for at least one day.",
  "plan.remove": "Remove hours",
  "calls.afterHours": "After hours",
  "calls.closedDay": "Closed day",
  "numbers.accounts": "Connected SIP accounts",
  "numbers.accounts.hint": "A business can connect several accounts; each account can have several numbers.",
  "numbers.count": "{n} numbers",
  "lines.test": "Test",
  "lines.connectTest": "Connect and test",
  "lines.test.again": "Test again",
  "lines.test.busy": "Connecting…",
  "lines.test.running": "Connecting to the provider… ({s} s)",
  "lines.test.ok": "Connected: the line registered with the provider. You can continue.",
  "lines.test.rejected": "The provider rejected the username or password. Fix them and test again.",
  "lines.test.waiting": "No answer from the provider yet. You can continue; the connection state will show in the list.",
  "lines.test.unknown": "The connection state cannot be read right now. You can continue; the state will show in the list.",
  "lines.invalid.host": "“SIP server” is invalid: enter a lowercase host name (e.g. sip.example.com) or an IP address, without http:// or spaces.",
  "lines.invalid.username": "“SIP username” is invalid: no spaces and none of: @ ; : # % \" < > [ ] \\",
  "lines.invalid.authUsername": "“Authentication user” is invalid: no spaces and none of: @ ; : # % \" < > [ ] \\",
  "lines.invalid.password": "“SIP password” is invalid: at most 128 characters, no spaces or backslash (\\).",
  "lines.invalid.port": "“Port” must be between 1 and 65535.",
  "error.LINE_EXISTS": "This SIP account (same server and username) is already connected on the platform. Adding it twice would drop the existing connection; use the line in the list.",
  "numbers.sameAccount": "This SIP account is already connected (“{name}”). I selected that line and am testing its connection.",
  "numbers.alreadyListed": "This number is already in your list. Choose its answering and calling agents in the numbers table.",
  "agent.tab.routing": "Routing",
  "routing.title": "Routing by topic",
  "routing.hint": "Write the topics callers ask about in your own words and choose where each goes. The agent understands what the caller needs and asks one question if needed. Then it hands the call to the agent or number you chose, or takes a message. With an empty list the agent handles every call itself.",
  "routing.empty": "No topics yet. Add topics for a receptionist agent (e.g. Bookings, Billing, Technical support).",
  "routing.topic": "Topic",
  "routing.topic.placeholder": "Topic name (e.g. Bookings)",
  "routing.description": "What it covers",
  "routing.description.placeholder": "What do callers want here? (e.g. new booking, date change, cancellation)",
  "routing.target": "Where",
  "routing.target.self": "The agent takes a message",
  "routing.target.agent": "Hand to AI agent: {name}",
  "routing.target.phone": "Transfer to a phone number",
  "routing.phone": "Number to transfer to",
  "routing.add": "Add topic",
  "routing.needCallback": "For topics where the agent takes a message, turn on callbacks in the Actions tab so the agent can agree a time with the caller.",
  "routing.badPhone": "Write the transfer number with its country code (+1…).",
  "routing.phoneNote": "Transfers go out through the line the call came in on. If nobody answers (busy, out of hours) the call comes back to the agent, which apologises and notes the topic and a callback time.",
  "routing.phone.placeholder": "+1 555 000 0000",
  "routing.summary": "Connected: {connected} of {total} topics · Agent takes a message: {message}",
  "routing.allMessage": "No topic connects callers to anyone: on every topic the agent takes a message.",
  "routing.notPublished": "The chosen agent is not published yet, so calls cannot be handed to it. Until it is, this agent takes a message on this topic.",
  "studio.askingNow": "Being asked now",
  "fieldHelp.identity.brandName": "The agent says on every call that it speaks for this business.",
  "fieldHelp.identity.name": "The agent introduces itself with this name (“I'm Emma”). Pick a friendly name or one that fits your brand.",
  "fieldHelp.identity.persona": "How the agent comes across: e.g. “friendly, patient adviser” or “quick, clear assistant”.",
  "fieldHelp.languages.primary": "The language the agent speaks and understands on the phone.",
  "fieldHelp.direction": "Will the agent call people (outbound) or answer calls to your business (inbound)? Its opening changes accordingly.",
  "fieldHelp.mission.goal": "What it tries to achieve on every call; it steers the conversation there. E.g. “book an appointment”.",
  "fieldHelp.mission.audience": "Who it talks to; it picks words and examples for them.",
  "fieldHelp.mission.successCondition": "What a good call looks like (e.g. an appointment is booked). Call summaries and reports use it.",
  "fieldHelp.facts": "What to find out on the call (e.g. name, need, a good time). Shown on the call card and in reports.",
  "fieldHelp.style.tone": "The feel of the conversation: e.g. “friendly and brief”, “formal and polite”. Applied to every sentence.",
  "fieldHelp.compliance.require[recording_notice].instruction": "The sentence saying the call is recorded. A legal requirement in many countries; said at the start of every call.",
  "fieldHelp.compliance.require[ai_disclosure].instruction": "The sentence telling the person they are speaking with an AI assistant, so nobody is misled.",
  "fieldHelp.globalIntents[opt_out].description": "How it recognises “don't call me again”; that number is then never called again.",
  "lang.label": "Language",
  "crash.title": "Something went wrong on this page",
  "crash.hint": "Reload the page. If it happens again, send the text below to support.",
  "crash.reload": "Reload page",
  "nav.testRoom": "Test room",
  "room.title": "Test room",
  "room.subtitle": "Let your agent talk to a simulated customer with real voices. The conversation is recorded like a real call; no phone line or minutes are used.",
  "room.agent": "Agent to test",
  "room.noAgents": "No published agent yet. Publish an agent first.",
  "room.direction": "Call direction",
  "room.direction.outbound": "The agent calls the customer",
  "room.direction.inbound": "The customer calls the business",
  "room.persona": "Customer type",
  "room.persona.interested": "Interested",
  "room.persona.interested.hint": "Answers questions, asks practical ones, accepts a clear next step.",
  "room.persona.busy": "Busy",
  "room.persona.busy.hint": "In the middle of work; very short answers, accepts a quick callback offer.",
  "room.persona.skeptical": "Skeptical",
  "room.persona.skeptical.hint": "Asks where you got the number, what you sell and the price; wants straight answers.",
  "room.persona.rude": "Rude",
  "room.persona.rude.hint": "Annoyed by the call; short and sharp. Tests whether the agent stays calm.",
  "room.persona.refusal": "Refuses",
  "room.persona.refusal.hint": "Clearly not interested; tests whether the agent closes politely.",
  "room.persona.confused": "Confused",
  "room.persona.confused.hint": "Does not follow, asks again; tests plain explanations.",
  "room.persona.competitor_happy": "Happy with a competitor",
  "room.persona.competitor_happy.hint": "Works with another company and is happy; tests how the agent shows the difference.",
  "room.scenario": "Customer situation (optional)",
  "room.scenario.placeholder": "e.g. Has a booking for tomorrow, wants to cancel without paying a fee.",
  "room.scenario.hint": "Describe a real situation from your customers; the simulated customer speaks as if living it.",
  "room.voice": "Customer voice",
  "room.voice.default": "Platform default",
  "room.start": "Start conversation",
  "room.starting": "Starting…",
  "room.cost": "No phone minutes are used; only AI usage is charged to your account.",
  "room.history": "Recent conversations",
  "room.empty": "No test conversations yet.",
  "room.pick": "Start a conversation on the left or pick one from the list.",
  "room.running": "Conversation in progress… The recording and transcript open here when it ends.",
  "room.failed": "The conversation could not start. Try again shortly.",
  "room.status.created": "Starting",
  "room.status.live": "Live",
  "room.status.ended": "Ended",
  "room.status.failed": "Failed",
  "room.heard.title": "Did the agent hear it right?",
  "room.heard.hint": "Left: what the customer said. Right: what the agent heard. Differences show speech recognition errors.",
  "room.heard.said": "Customer said",
  "room.heard.heard": "Agent heard",
  "room.heard.none": "(not heard)",
  "error.ROOM_NOT_CONFIGURED": "The test room is not available on this installation.",
  "nav.room": "Test room",
  "templates.agentLanguage": "Language the agent speaks",
  "templates.language.tr-TR": "Turkish",
  "templates.language.en-US": "English",
  "templates.language.ar-SA": "Arabic",
  "templates.sector": "Industry",
  "templates.structure": "Call type",
  "templates.direction": "Direction",
  "templates.all": "All",
  "templates.own": "Your template",
  "templates.otherLanguage": "Not in this language (showing {lang})",
  "templates.none": "No template matches. Change the filters or start blank.",
  "templates.filled": "The template was filled with your business details: {list}.",
  "templates.unresolved": "Not found in your knowledge base (the studio asks if needed): {list}.",
  "templates.var.business.name": "business name",
  "templates.var.business.website": "website",
  "templates.var.business.phone": "phone",
  "templates.var.business.email": "email",
  "templates.var.business.address": "address",
  "templates.var.business.city": "city",
  "templates.var.business.hours": "opening hours",
  "templates.var.business.offer": "what you offer",
  "sector.general": "General",
  "sector.hospitality": "Hotels & hospitality",
  "sector.healthcare": "Healthcare & clinics",
  "sector.insurance": "Insurance",
  "sector.real_estate": "Real estate",
  "sector.b2b_supply": "B2B sales & supply",
  "sector.ecommerce": "E-commerce & delivery",
  "sector.education": "Education & courses",
  "sector.automotive": "Automotive & service",
  "structure.receptionist": "Reception & routing",
  "structure.support": "Customer support",
  "structure.appointment": "Appointments",
  "structure.sales": "Sales call",
  "structure.lead_qualification": "Lead qualification",
  "structure.survey": "Satisfaction survey",
  "structure.reminder": "Reminder",
  "structure.follow_up": "Follow-up",
  "structure.renewal": "Renewal",
  "templates.panel.title": "Template",
  "templates.panel.none": "This agent was not made from a template.",
  "templates.save": "Save as template",
  "templates.save.hint": "This agent's setup becomes your own template; only you see it and can create new agents from it.",
  "templates.save.newVersion": "This agent comes from your template: saving creates a new version of it.",
  "templates.save.name": "Template name",
  "templates.save.description": "Short description",
  "templates.save.changelog": "What changed in this version?",
  "templates.save.button": "Save",
  "templates.save.done": "Template saved (version {v}).",
  "templates.update.title": "A new template version is available: v{v}",
  "templates.update.apply": "Fields that will be updated: {list}.",
  "templates.update.keep": "Fields you changed, which will be kept: {list}.",
  "templates.update.hint": "The live agent does not change by itself: publish after applying.",
  "templates.update.button": "Apply v{v}",
  "templates.update.done": "v{v} applied ({n} fields updated). Remember to publish.",
  "templates.field.mission.goal": "Call goal",
  "templates.field.mission.successCondition": "Success condition",
  "templates.field.mission.audience": "Audience",
  "templates.field.style.tone": "Tone",
  "templates.field.style.maxSentencesPerTurn": "Reply length",
  "templates.field.facts": "Details to collect",
  "templates.field.boundaries.blockedTopics": "Topics to avoid",
  "templates.field.boundaries.mustNotPromise": "Never promise",
  "templates.field.globalIntents.extra": "Special cases",
  "templates.field.statements.extra": "Business answers",
  "templates.field.routes": "Routing topics",
  "error.TEMPLATE_UP_TO_DATE": "The agent already uses the latest template version.",
  "error.TEMPLATE_NOT_LINKED": "This agent is not linked to a template.",
  "nav.readyAgents": "Ready agents",
  "nav.templates": "Ready agents",
  "ready.title": "Ready agents",
  "ready.subtitle": "Pick a ready agent by language, industry and direction; it is filled with your business details and created in one step.",
  "ready.toStudio": "Build from scratch by chat",
  "ready.loading": "Reading your business details…",
  "ready.goal": "What the agent does",
  "ready.collects": "Details it collects",
  "ready.routes": "Topics it routes",
  "ready.answers": "Answers it gives for your business",
  "ready.never": "Things it never promises",
  "ready.name": "Agent name",
  "ready.contactSource": "Where do the numbers you call come from?",
  "ready.contactSource.placeholder": "e.g. Customers who contacted us before",
  "ready.contactSource.hint": "If a customer asks \"where did you get my number?\" the agent says this. It must be true, so we ask you.",
  "ready.optional": "optional",
  "ready.incomplete": "This template is missing fields; please build it in the studio.",
  "ready.create": "Create agent",
  "ready.creating": "Creating…",
  "ready.after": "Once created, its sales kit is prepared automatically; then you test and publish. You can change everything later.",
  "ready.fromStudio": "Choose a ready agent",
  "ready.fromStudio.hint": "Ready agents for your industry, filled with your details; one step, no interview.",
  "error.TEMPLATE_INPUT_MISSING": "Some information is missing to create it.",
  "nav.stats": "Statistics",
  "stats.title": "Statistics",
  "stats.subtitle": "What your agents did and what it brought you. Only real calls count; test calls are excluded.",
  "stats.period": "Period",
  "stats.lastDays": "Last {n} days",
  "stats.agent": "Agent",
  "stats.allAgents": "All agents",
  "stats.allDirections": "Inbound + outbound",
  "stats.empty": "No real calls in this period. Start a campaign or connect your number to an agent.",
  "stats.kpi.calls": "Calls",
  "stats.kpi.answered": "{p}% answered",
  "stats.kpi.talked": "Conversations",
  "stats.kpi.avg": "avg {d} min",
  "stats.kpi.minutes": "Talk minutes",
  "stats.kpi.minutesNote": "total of answered calls",
  "stats.kpi.hot": "Hot leads",
  "stats.kpi.hotNote": "{p}% of conversations · {warm} warm",
  "stats.kpi.callbacks": "Callbacks",
  "stats.kpi.callbacksNote": "agreed next call",
  "stats.kpi.optOuts": "Opt-outs",
  "stats.kpi.optOutsNote": "{p}% of answered · added to the list",
  "stats.kpi.machine": "Voicemail",
  "stats.kpi.machineNote": "the agent hung up at once",
  "stats.kpi.mood": "Positive tone",
  "stats.kpi.moodNote": "{n} negative conversations",
  "stats.daily.title": "Daily calls and outcomes",
  "stats.daily.hint": "How many calls each day and how interested customers were.",
  "stats.showTable": "Show as table",
  "stats.showChart": "Show as chart",
  "stats.seg.hot": "Hot",
  "stats.seg.warm": "Warm",
  "stats.seg.cold": "Cold",
  "stats.seg.notReached": "Not reached",
  "stats.seg.unscored": "Not scored",
  "stats.col.day": "Day",
  "stats.col.answered": "Answer rate",
  "stats.col.avg": "Avg length",
  "stats.funnel.title": "Call funnel",
  "stats.funnel.hint": "From called to next step: how many remain at each stage.",
  "stats.funnel.dialed": "Called",
  "stats.funnel.answered": "Answered",
  "stats.funnel.talked": "Talked",
  "stats.funnel.interested": "Interested",
  "stats.funnel.next": "Next step",
  "stats.funnel.ofFirst": "{p}% of called",
  "stats.heat.title": "Activity by day and hour",
  "stats.heat.hint": "Darker squares mean more calls: for outbound, when people pick up; for inbound, your busiest hours.",
  "stats.heat.read": "{n} calls, {a} answered",
  "stats.heat.hover": "Hover a square for details.",
  "stats.agents.title": "By agent",
  "stats.topics.title": "What callers asked about",
  "stats.topics.hint": "Topics your reception agent routed.",
  "stats.dow.1": "Mon",
  "stats.dow.2": "Tue",
  "stats.dow.3": "Wed",
  "stats.dow.4": "Thu",
  "stats.dow.5": "Fri",
  "stats.dow.6": "Sat",
  "stats.dow.7": "Sun",
  "stats.usage.title": "Usage and cost",
  "stats.usage.rates": "{c} credits per call + {m} credits per started minute (from your Panaryus plan).",
  "stats.usage.unavailable": "Plan details are unavailable right now; only billable minutes are shown.",
  "stats.usage.billable": "Billable minutes",
  "stats.usage.billableNote": "{n} answered calls, minutes rounded up",
  "stats.usage.spent": "Credits spent in this period",
  "stats.usage.spentNote": "call + minute credits",
  "stats.usage.perHot": "Per hot lead",
  "stats.usage.perHotNote": "credits",
  "stats.usage.perCallback": "Per callback",
  "stats.usage.perCallbackNote": "credits",
  "stats.usage.credits": "Credits left",
  "stats.usage.creditsNote": "in your Panaryus account",
  "stats.usage.plan": "Plan: {plan} — voice minutes",
  "stats.usage.minutes": "{used} / {limit} min",
  "stats.usage.unlimited": "{used} min (unlimited)",
  "stats.usage.near": "Over 90% of your plan minutes are used. Calls stop when they run out; consider upgrading.",
  "stats.campaigns.title": "Compare campaigns",
  "stats.campaigns.hint": "Which list and agent brought the most interested customers for the credits spent. Hot rate is out of conversations.",
  "stats.campaigns.name": "Campaign",
  "stats.campaigns.list": "Reached / list",
  "stats.campaigns.hotRate": "Hot leads",
  "stats.campaigns.credits": "Credits",
  "stats.campaigns.best": "Best",
  "create.hero.title": "Let's create the right agent for you, the easy way",
  "ready.hero.body": "Pick a ready agent for your industry; it fills in with your business details and is ready in one step. Can't find it? Tell us what you need and we'll find it together.",
  "studio.hero.body": "Tell us what you need; the AI asks step by step and we build your agent together. Faster: pick a ready agent for your industry.",
  "studio.hero.start": "Start building by chat",
  "ready.finder.open": "Can't find it? Let's solve it quickly",
  "ready.finder.title": "Let's find the right agent",
  "ready.finder.ask": "What should your agent do? Write it in your own words, e.g. \"Answer calls to my dental clinic and book appointments.\" or \"Call past customers about our new offer.\"",
  "ready.finder.placeholder": "What do you want the agent to do?",
  "ready.finder.use": "Choose this agent",
  "ready.finder.noneFit": "None of these fit?",
  "ready.finder.noMatch": "No ready agent fits; let's build a custom one.",
  "ready.finder.custom": "Build a custom agent by chat",
  "ready.finder.close": "Close",
  "nav.group.platform": "Platform",
  "nav.templateNeeds": "Template needs",
  "nav.needs": "Template needs",
  "platform.needs.title": "Template needs",
  "platform.voice.title": "Turkish voice (EMA)",
  "platform.voice.on": "Running",
  "platform.voice.off": "Off",
  "platform.voice.unreachable": "Not reachable",
  "platform.voice.load": "In use {active} of {max} · served {served} · busy refusals {busy}",
  "platform.voice.lastHour": "Last hour: {emaCalls} calls on EMA, {fellBack} moved to the backup voice ({fallbacks} switches) · voice failures in all calls: {failed}",
  "platform.needs.subtitle": "What businesses asked the \"Can’t find it?\" finder for — across all businesses, labels and counts only (no business, no text). No-match rows first: the next templates to write.",
  "platform.needs.empty": "The finder was not used in this period.",
  "platform.needs.industry": "Industry",
  "platform.needs.callType": "Call type",
  "platform.needs.requests": "Requests",
  "platform.needs.businesses": "Businesses",
  "platform.needs.noMatch": "No ready agent",
  "platform.needs.choseTemplate": "Chose a suggestion",
  "platform.needs.choseCustom": "Built custom",
  "platform.needs.write": "Write a template",
  "platform.needs.hint": "\"Write a template\": at least 2 businesses asked and no ready agent fitted at least 3 times. Industry and call type are short English labels from the AI.",
  "error.PLATFORM_ADMIN_ONLY": "This screen is for platform operators only.",
  "agent.tab.readiness": "Readiness",
  "readiness.title": "Agent readiness: {score}%",
  "readiness.subtitle": "The questions your callers will ask, plus a few settings. The more you answer, the more the agent can handle itself; otherwise it offers a callback.",
  "readiness.publishNote": "Saved answers go into the draft and are used in live calls once you publish. The agent works even if you leave them empty.",
  "readiness.suggest.none": "This agent did not come from a ready template, so it has no question list. AI can suggest questions for your business.",
  "readiness.suggest.more": "You can also add more questions specific to your business.",
  "readiness.suggest.button": "Let AI suggest questions",
  "readiness.suggest.running": "Preparing questions…",
  "readiness.group.missing": "Missing ({n})",
  "readiness.group.done": "Done ({n})",
  "readiness.group.dismissed": "Not applicable ({n})",
  "readiness.impact.high": "Very important",
  "readiness.impact.medium": "Important",
  "readiness.impact.low": "Helpful",
  "readiness.fill": "Fill with AI",
  "readiness.edit": "Edit",
  "readiness.dismiss": "Does not apply",
  "readiness.undismiss": "Undo",
  "readiness.setting.go": "Set up",
  "readiness.setting.hours.title": "Business hours and time zone",
  "readiness.setting.hours.why": "The agent uses them for when to call, \"are you open\" questions and callback times.",
  "readiness.setting.voice.title": "Agent voice",
  "readiness.setting.voice.why": "A voice that fits your brand builds caller trust and keeps calls going longer.",
  "readiness.setting.transfers.title": "Transfer numbers",
  "readiness.setting.transfers.why": "When a caller asks for a person, the agent transfers the call here; without them it can only take a note.",
  "readiness.setting.routing_unreachable.title": "Publishing the agents your topics go to",
  "readiness.setting.routing_unreachable.why": "A topic handed to an agent that is not published never reaches it: the call falls back to taking a message. Publish that agent or choose another target.",
  "readiness.setting.routing_callback.title": "Callbacks for topics that take a message",
  "readiness.setting.routing_callback.why": "On these topics the agent takes a message. Turn on callbacks so it can also agree a time to call the caller back.",
  "readiness.setting.contact_source.title": "Where your contacts come from",
  "readiness.setting.contact_source.why": "\"Where did you get my number?\" is the most common outbound question; an agent without a clear answer loses trust.",
  "readiness.card.title": "Agent readiness {score}%",
  "readiness.card.open": "Complete missing info",
  "readiness.card.high": "{n} very important items missing ({total} in total). The agent works, but will offer a callback on these questions.",
  "readiness.card.some": "{n} items missing. The more you fill in, the more the agent answers itself.",
  "readiness.assist.placeholder": "Write the answer in your own words (e.g. prices, hours, conditions)…",
  "readiness.assist.draft": "What the agent will say",
  "readiness.assist.draftPlaceholder": "You can also type it here yourself.",
  "readiness.assist.draftHint": "The agent uses this sentence as is. The AI never invents numbers or facts it was not given.",
  "readiness.assist.save": "Save",
  "overview.att.readiness": "{name}: {n} important items missing",
  "overview.att.readiness.body": "The agent is working (readiness {score}%) but cannot give a clear answer to these questions.",
  "overview.att.readiness.cta": "Complete missing info",
  "readiness.assist.opening": "I couldn't find anything about this in your information. When a caller asks \"{question}\", what should the answer be? Write it briefly in your own words and I'll turn it into what the agent will say.",
  "stats.unanswered.title": "Questions the agent could not answer",
  "stats.unanswered.hint": "Questions customers asked in real calls that the agent could not answer clearly. Add the answer and the agent will handle it next time.",
  "stats.unanswered.open": "{n} questions need an answer",
  "stats.unanswered.empty": "None yet. They are collected here as new calls finish.",
  "stats.unanswered.question": "Question",
  "stats.unanswered.calls": "Calls",
  "stats.unanswered.lastCall": "Open the latest call",
  "stats.unanswered.add": "Add the answer",
  "stats.unanswered.done": "Answer added",
  "stats.unanswered.why": "Customers asked this {n} times in real calls and the agent could not answer. Once answered, the agent handles it itself.",
  "stats.endings.title": "Where did calls end?",
  "stats.endings.hint": "The stage in which talked calls ended and how many the customer hung up. The stage where most customers hang up is the one to improve.",
  "stats.endings.empty": "Not enough longer calls in this period.",
  "stats.endings.row": "{n} calls · customer hung up {c} · interested {i}",
  "stats.endings.hungUp": "customer hung up {n}",
  "stats.stage.opening": "Opening",
  "stats.stage.discovery": "Understanding needs",
  "stats.stage.pitch": "Offer",
  "stats.stage.objection": "Objection",
  "stats.stage.closing": "Closing",
  "stats.stage.ended": "Ended",
  "stats.endings.advice.opening": "{n} customers hung up during the opening. A shorter first sentence that says why you are calling usually makes the biggest difference.",
  "stats.endings.advice.discovery": "{n} customers hung up during the questions. Try fewer, shorter questions.",
  "stats.endings.advice.pitch": "{n} customers hung up during the offer. Try presenting it with one clear benefit and refresh the sales kit.",
  "stats.endings.advice.objection": "{n} customers hung up after an objection. Add ready answers to common objections in the sales kit.",
  "stats.cb.title": "Callback promises",
  "stats.cb.hint": "Were the callbacks the agent promised kept? Called on time, customer reached?",
  "stats.cb.empty": "No callback promises in this period.",
  "stats.cb.summary": "{n} promised · {onTime} of {placed} placed calls on time ({p}%)",
  "stats.cb.reached": "Called, reached",
  "stats.cb.notReached": "Called, no answer",
  "stats.cb.team": "Handled by your team",
  "stats.cb.waiting": "Waiting for its time",
  "stats.cb.late": "Overdue",
  "stats.cb.failed": "Could not call",
  "stats.cb.manual": "To call manually",
  "stats.cb.reached.hint": "The agent called at the promised time and the customer answered.",
  "stats.cb.notReached.hint": "The agent called but the customer did not answer or voicemail picked up.",
  "stats.cb.team.hint": "Your team marked it done.",
  "stats.cb.waiting.hint": "Not due yet; the agent will call automatically.",
  "stats.cb.late.hint": "More than 10 minutes past due and not called.",
  "stats.cb.failed.hint": "The agent could not place the call; the reason is below.",
  "stats.cb.manual.hint": "Promises that cannot be called automatically (e.g. no clear time); your team needs to call.",
  "stats.cb.open": "Open call",
  "stats.cb.error.PHONE_NOT_E164": "number format not recognized",
  "stats.cb.error.DO_NOT_CALL": "customer asked not to be called",
  "stats.cb.error.AGENT_NOT_PUBLISHED": "agent not published",
  "stats.cb.error.OUTSIDE_HOURS": "outside business hours",
  "stats.cb.error.ORIGINATE_FAILED": "the line could not place the call",
  "stats.cb.error.BILLING_PRINCIPAL_MISSING": "account details missing",
  "stats.cb.error.other": "could not call",
  "agent.tab.offerings": "Products",
  "offerings.title": "Products and services",
  "offerings.subtitle": "What the agent presents in calls. The order is the priority: the agent presents the first one that fits.",
  "offerings.suggest": "Let AI suggest from my knowledge",
  "offerings.suggesting": "Reading your knowledge…",
  "offerings.rule.order": "The top item is presented first; reorder with the arrows.",
  "offerings.rule.outbound": "On outbound calls the agent first asks briefly about the need, presents the item that fits and moves to the next if there is no interest. At most 3 per call.",
  "offerings.rule.inbound": "On inbound calls it talks about what the caller asks; it suggests another item only if it fits, near the end.",
  "offerings.rule.truth": "The agent only says what is written here; it never invents a price or condition.",
  "offerings.found": "{n} products/services found — pick the ones to add",
  "offerings.none": "No products or services found in your knowledge. You can add them by hand.",
  "offerings.suggest.hint": "The AI only suggests what your Business Brain says; check and save.",
  "offerings.addPicked": "Add {n}",
  "offerings.empty": "No products yet. Let the AI suggest them or add them by hand.",
  "offerings.rank": "Priority {n}",
  "offerings.summary.missing": "Description missing",
  "offerings.up": "Move up",
  "offerings.down": "Move down",
  "offerings.name": "Name",
  "offerings.summary": "What it is (one sentence)",
  "offerings.summary.hint": "In everyday words; the agent says it in its own words.",
  "offerings.benefits": "Benefits (one per line, up to 3)",
  "offerings.benefits.hint": "A concrete gain for the customer, e.g. time, money, ease.",
  "offerings.fits": "Who / which need it fits",
  "offerings.terms": "Price or conditions (optional)",
  "offerings.terms.hint": "If you write a price or condition the agent says it as is; if empty, it says it does not have that detail.",
  "offerings.remove": "Remove this item",
  "offerings.add": "Add product",
  "offerings.new": "New product",
  "offerings.unsaved": "Unsaved changes",
  "offerings.publishNote": "After saving, publish the agent to use it in live calls.",
  "campaigns.focus": "Products to feature",
  "campaigns.focus.hint": "Ticked items are presented first in this campaign; the rest follow the agent's order.",
  "campaigns.focus.none": "This agent has no product list; add one on the agent's Products tab.",
  "campaigns.focus.default": "The agent's order",
  "stats.offerings.title": "Product interest",
  "stats.offerings.hint": "Products and services the agents presented in calls, and whether customers showed interest or stayed cold.",
  "stats.offerings.item": "Product / service",
  "stats.offerings.presented": "Presented",
  "stats.offerings.interest": "Interest",
  "stats.offerings.cold": "Cold",
  "offerings.saved": "Products saved. Publish the agent to use them in live calls.",
  "offerings.incomplete": "To save, every product needs a name and a description: {names}",
  "greeting.title": "Opening",
  "greeting.hint": "How should the agent open the call? A short greeting first, then waiting for the reply, sounds more natural.",
  "greeting.full": "Full opening in one line",
  "greeting.full.hint": "Greeting, who it is, the required disclosures and the reason in the first line.",
  "greeting.greet": "Greeting first",
  "greeting.greet.hint": "The first line is only a greeting; the introduction and disclosures follow the customer's reply.",
  "greeting.lines": "Greeting lines (one per line, up to 5)",
  "greeting.lines.hint": "One is used per call, in turn. Write {brand} to insert your business name.",
  "greeting.suggestions": "Suggestions:",
  "greeting.legal": "The AI and recording disclosures are said in the agent's second line, when it introduces itself.",
  "offerings.counts": "{v} variants · {q} questions · {x} objections",
  "offerings.details.title": "Variants and product kit",
  "offerings.details.hint": "When the customer is interested, the agent suggests 1–2 fitting variants and answers questions and objections with the answers here.",
  "offerings.details.fill": "Fill with AI",
  "offerings.details.found": "{n} suggestions found — pick the ones to add",
  "offerings.details.none": "No suggestions found for this product in your knowledge. You can add them by hand.",
  "offerings.variant": "Variant",
  "offerings.faq": "Question",
  "offerings.objection": "Objection",
  "offerings.variants": "Variants",
  "offerings.variant.name": "Name (e.g. brand, model, package)",
  "offerings.variant.summary": "Short description",
  "offerings.variant.terms": "Price / condition",
  "offerings.variant.add": "Add variant",
  "offerings.faqs": "Frequently asked questions",
  "offerings.faq.q": "Customer's question",
  "offerings.faq.a": "Agent's answer",
  "offerings.faq.add": "Add question",
  "offerings.objections": "Objections",
  "offerings.objection.q": "Customer's objection",
  "offerings.objection.a": "Agent's answer",
  "offerings.objection.add": "Add objection",
  "offerings.row.remove": "Remove",
  "nav.aiCalls": "Calls & AI usage",
  "platform.calls.title": "Calls and AI usage",
  "platform.calls.subtitle": "Every call of every business: which AI models it used, how many tokens and the estimated model cost. Click a call for details.",
  "platform.calls.kind.all": "All",
  "platform.calls.kind.real": "Real calls",
  "platform.calls.kind.room": "Test room",
  "platform.calls.room": "Test room",
  "platform.calls.tenantFilter": "Business id (e.g. ten_pu_5432)",
  "platform.calls.onPage": "On this page",
  "platform.calls.inputTokens": "Input tokens",
  "platform.calls.outputTokens": "Output tokens",
  "platform.calls.cached": "Cached",
  "platform.calls.cost": "Estimated cost",
  "platform.calls.empty": "No calls.",
  "platform.calls.date": "Date",
  "platform.calls.business": "Business",
  "platform.calls.agent": "Agent",
  "platform.calls.customer": "Customer",
  "platform.calls.type": "Type",
  "platform.calls.duration": "Duration",
  "platform.calls.turns": "Turns",
  "platform.calls.models": "Models",
  "platform.calls.model": "Model",
  "platform.calls.tokens": "Tokens (in/out)",
  "platform.calls.hint": "Cost is estimated from the price table (templates/defaults/llm-prices.json); SuperGrok is a subscription, so 0. Calls before 28.09.2026 have no usage record.",
  "platform.calls.newer": "← Newer",
  "platform.calls.older": "Older →",
  "platform.calls.back": "Back to calls",
  "platform.calls.modelCalls": "Model calls",
  "platform.calls.summary": "Summary",
  "platform.calls.scenario": "Test scenario",
  "platform.calls.modelsUsed": "Models used",
  "platform.calls.noUsage": "No usage recorded for this call (calls before 28.09.2026 have none).",
  "platform.calls.job": "Job",
  "platform.calls.avgTime": "Avg. time",
  "platform.calls.unpriced": "No price in the table for: {models}",
  "platform.calls.conversation": "Conversation",
  "platform.calls.conversationHint": "Per turn: what the agent heard and said, how fast it started speaking and the tokens of the turn.",
  "platform.calls.noTurns": "No turns recorded.",
  "platform.calls.firstWord": "first word {s} s",
  "platform.calls.turnTokens": "tokens {in} → {out} (cached {cached})",
  "platform.calls.critics": "checks stepped in: {list}",
  "platform.calls.role.conductor": "Agent (speaking)",
  "platform.calls.role.test_agent": "Test agent",
  "platform.calls.role.judge": "In-call checks",
  "platform.calls.role.bridge": "Filler",
  "platform.calls.role.simulator": "Test customer",
  "platform.calls.role.analyst": "Call analysis",
  "eval.title": "Call scorecard (AI judge)",
  "eval.unsure": "check",
  "eval.unsureHint": "The judge is not sure about this answer; check the transcript.",
  "eval.score.opening": "Opening",
  "eval.score.discovery": "Discovery",
  "eval.score.objection_handling": "Objection handling",
  "eval.score.closing": "Closing / next step",
  "eval.score.clarity": "Clarity and brevity",
  "eval.flag.said_recording_notice": "Recording notice said",
  "eval.flag.said_ai_disclosure": "AI disclosure said",
  "eval.flag.agent_missed_question": "A question was left unanswered",
  "eval.flag.agent_repeated": "Agent repeated itself",
  "eval.flag.agent_ended_early": "Ended too early",
  "eval.flag.alert_complaint": "Complaint / angry customer",
  "eval.choice.outcome": "Outcome",
  "eval.choice.loss_reason": "Loss reason",
  "eval.choice.drop_stage": "Where it went wrong",
  "eval.choice.sentiment_end": "Mood at the end",
  "eval.choice.outcome.next_step": "Next step agreed",
  "eval.choice.outcome.callback": "Callback",
  "eval.choice.outcome.interested": "Interested, no step",
  "eval.choice.outcome.not_interested": "Not interested",
  "eval.choice.outcome.opted_out": "Opted out",
  "eval.choice.outcome.no_conversation": "No conversation",
  "eval.choice.outcome.unclear": "Unclear",
  "eval.choice.loss_reason.price_or_terms": "Price / terms",
  "eval.choice.loss_reason.has_provider": "Already has a provider",
  "eval.choice.loss_reason.timing": "Timing",
  "eval.choice.loss_reason.not_decision_maker": "Not the decision maker",
  "eval.choice.loss_reason.no_need": "No need",
  "eval.choice.loss_reason.distrust": "Distrust",
  "eval.choice.loss_reason.agent_problem": "Agent problem",
  "eval.choice.loss_reason.other": "Other",
  "eval.choice.loss_reason.not_applicable": "—",
  "eval.choice.drop_stage.opening": "Opening",
  "eval.choice.drop_stage.discovery": "Discovery",
  "eval.choice.drop_stage.presentation": "Presentation",
  "eval.choice.drop_stage.objection": "Question / objection",
  "eval.choice.drop_stage.closing": "Closing",
  "eval.choice.drop_stage.none": "Did not drop",
  "eval.choice.sentiment_end.positive": "Positive",
  "eval.choice.sentiment_end.neutral": "Neutral",
  "eval.choice.sentiment_end.negative": "Negative",
  "eval.questions": "Customer questions ({a}/{n} answered)",
  "eval.answered": "Answered",
  "eval.notAnswered": "Not answered",
  "eval.objection": "Objection",
  "quality.title": "Call quality",
  "quality.subtitle": "After each call an AI judge (JEV) evaluates it: scorecard, rules, outcome, questions and kit use.",
  "quality.source.real": "Real calls",
  "quality.source.room": "Test room",
  "quality.empty": "No evaluated calls in this period.",
  "quality.emptyReal": "Real calls are not evaluated yet (starts when the platform admin turns it on). You can look at test-room calls.",
  "quality.scorecard": "Scorecard average ({n} calls)",
  "quality.rules": "Rules and mistakes",
  "quality.lossReasons": "Why we lost",
  "quality.noLoss": "No losses.",
  "quality.dropStage": "Where it went wrong",
  "quality.questions": "Customer questions ({n}, {p}% answered)",
  "quality.questionsHint": "Unanswered: questions the agent did not know or evaded. Add the answer to the product kit or the Business Brain and the agent answers next time.",
  "quality.allAnswered": "All questions were answered.",
  "quality.openCall": "Open call",
  "quality.kit": "Product kit use",
  "quality.kitHint": "Which kit item each customer question matched. Never-used items and unanswered ones are marked.",
  "quality.kitItem": "Item",
  "quality.kitKind": "Type",
  "quality.kitUsed": "Used",
  "quality.kitUnanswered": "Unanswered",
  "quality.neverUsed": "never",
  "quality.kind.offering": "Product",
  "quality.kind.faq": "FAQ",
  "quality.kind.objection": "Objection",
  "voice.engine.title": "Voice source",
  "voice.engine.hint": "Which system produces the agent's voice. If CenterVoice does not answer, the sentence is spoken with the standard voice automatically.",
  "voice.engine.standard": "Standard voice (ElevenLabs)",
  "voice.engine.standard.hint": "Pick from the voice library, speaking speed",
  "voice.engine.self_hosted": "CenterVoice",
  "voice.engine.self_hosted.hint": "Our own voice engine; voice choice and speaking speed",
  "voice.engine.ema": "CenterVoice Turkish (EMA)",
  "voice.engine.ema.hint": "Our own Turkish voice; calls in Turkish only. Other languages, or if it does not answer, use the backup voice for the rest of the call.",
  "voice.ema.sample": "Turkish voice sample",
  "voice.backup.title": "Backup voice",
  "voice.backup.hint": "When the main voice (EMA or the library voice) cannot speak a sentence, the call goes on in this voice. While the library voices are off it is also the standard voice. Pick a voice of the same gender as the agent's own voice.",
  "voice.backup.platformDefault": "Platform default",
  "platform.calls.estimated": "{n} estimated",
  "platform.calls.estimatedHint": "\"Estimated\": requests the agent started early and dropped when the customer kept talking. The provider does not report their tokens but bills the input; estimated from the request length at the rate measured in the same call.",
  "voice.engine.defaultVoice": "Default voice",
  "platform.calls.warn.voice": "backup voice {n}×",
  "platform.calls.warn.voiceHint": "Some sentences in this call were spoken with the backup voice, not the voice chosen for the agent (or were not spoken).",
  "platform.calls.warn.silence": "{s} s silence",
  "platform.calls.warn.silenceHint": "The agent stayed silent this long before a reply.",
  "calls.cost.title": "Usage and cost (estimate)",
  "calls.cost.service": "Service",
  "calls.cost.used": "What it used",
  "calls.cost.cost": "Estimate",
  "calls.cost.total": "Total",
  "calls.cost.note": "Estimated from unit prices, not an invoice. Visible to everyone during development; later only to administrators.",
  "calls.cost.ai": "AI models",
  "calls.cost.tts": "Voice (agent speech)",
  "calls.cost.stt": "Listening (speech → text)",
  "calls.cost.line": "Phone line",
  "calls.cost.tokens": "{calls} calls · {in} input ({cached} cached) · {out} output tokens",
  "calls.cost.chars": "{engine} · {chars} characters · ~{credits} credits",
  "calls.cost.minutes": "{minutes} min × {streams} streams",
  "calls.cost.lineMinutes": "{minutes} min",
  "calls.cost.unpriced": "Model without a price: {models}",
  "calls.cost.engine.standard": "ElevenLabs",
  "calls.cost.engine.self_hosted": "CenterVoice",
  "platform.calls.role.decider": "AI judge (JEV)",
  "contacts.import.empty": "Paste rows or choose a CSV file.",
  "contacts.form.title": "Add a person",
  "contacts.form.editTitle": "Edit person",
  "contacts.form.hint": "The agent uses the name, title and company in the call, so every call is personal. Only the phone is required.",
  "contacts.form.save": "Save",
  "contacts.form.cancel": "Cancel",
  "contacts.form.edit": "Edit",
  "contacts.optional": "optional",
  "contacts.field.name": "Full name",
  "contacts.field.name.placeholder": "e.g. Jane Smith",
  "contacts.field.phone": "Phone",
  "contacts.field.phone.hint": "With the country code (+1…). Saving the same number again updates the details.",
  "contacts.field.title": "Title",
  "contacts.field.title.placeholder": "e.g. Pharmacist, Purchasing manager",
  "contacts.field.company": "Company",
  "contacts.field.city": "City",
  "contacts.field.email": "Email",
  "contacts.field.note": "Note",
  "contacts.field.note.hint": "A short thing the agent should know (e.g. \"asked for prices last month\").",
  "call.fromContacts": "Pick from contacts",
  "call.picked": "Selected: {name} — the agent will know who it is calling.",
  "error.CALL_COUNTRY_NOT_ALLOWED": "Numbers in this country cannot be called: for security, only numbers in your line's country can be called. Contact support if you need another country.",
  "error.TOO_MANY_ACTIVE_CALLS": "The maximum number of calls at the same time has been reached. Try again when one ends.",
  "error.DAILY_CALL_LIMIT": "Today's limit for calls started from the panel has been reached. Try again tomorrow or use a campaign.",
  "agent.label.title": "Panel name",
  "agent.label.placeholder": "e.g. Outbound — marketing agent (Turkish)",
  "agent.label.hint": "Only you see it in the panel; it is never said on a call.",
  "agent.label.speaking": "Name on calls: {name}",
  "agent.label.none": "No panel name.",
  "agent.label.add": "Add a panel name",
  "agent.label.edit": "Change the panel name",
  "webcall.start": "Talk from the browser",
  "webcall.hint": "With the microphone, no phone line; no minutes used. Headphones recommended.",
  "webcall.connecting": "Connecting…",
  "webcall.live": "In call",
  "webcall.hangup": "End",
  "webcall.error.MIC_DENIED": "Microphone permission was not given. Allow the microphone from the browser's address bar.",
  "webcall.error.WEB_CALL_CONNECTION": "The voice connection could not be made.",
  "webcall.mute": "Mute",
  "webcall.unmute": "Unmute",
  "webcall.again": "Start again",
  "webcall.close": "Close",
  "webcall.status.agent": "Agent is speaking…",
  "webcall.status.user": "Listening to you",
  "webcall.status.listening": "Listening",
  "webcall.status.muted": "Your microphone is off",
  "webcall.status.ended": "Call ended",
  "room.mode.sim": "With a simulated customer",
  "room.mode.me": "I will talk",
  "room.mode.me.hint": "Talk to the agent with your microphone, no phone line. The call gets a recording and a scorecard like any other; no minutes used. Headphones recommended.",
  "webcall.begin": "Start the call",
  "webcall.section": "Try by voice (microphone)",
  "webcall.section.text": "Try by typing",
  "sms.title": "SMS account",
  "sms.hint": "Messages the agent sends from a call (summary, link) go from your business's own SMS account; your provider bills you. They go only to the number on the call, when the customer asks.",
  "sms.none": "No SMS account connected.",
  "sms.connect": "Connect an SMS account",
  "sms.provider.verimor": "Verimor SMS",
  "sms.username": "API username",
  "sms.username.hint": "At Verimor, usually your account number starting with the country code (e.g. 908501234567).",
  "sms.password": "API password",
  "sms.password.hint": "The password set in the provider's SMS API settings (not your login password).",
  "sms.sender": "Sender name",
  "sms.sender.hint": "One of your approved sender names; empty = the provider's default.",
  "sms.save": "Check and save",
  "sms.checking": "Checking…",
  "sms.saved": "SMS account verified and saved.",
  "sms.removed": "SMS account removed.",
  "sms.verified": "Verified",
  "sms.unverified": "Not verified",
  "sms.test": "Test SMS",
  "sms.test.to": "Number",
  "sms.test.to.hint": "International format, e.g. +44…",
  "sms.test.text": "Text",
  "sms.test.send": "Send",
  "sms.test.sent": "Test SMS sent.",
  "sms.parts": "{n} SMS",
  "sms.limits": "Limits: 3 per number per day, 2 per call.",
  "sms.log.when": "Time",
  "sms.log.to": "Number",
  "sms.log.kind": "Type",
  "sms.log.status": "Status",
  "sms.log.text": "Text",
  "sms.kind.test": "Test",
  "sms.kind.summary": "Summary",
  "sms.kind.link": "Link",
  "sms.status.sent": "Sent",
  "sms.status.failed": "Failed",
  "sms.status.refused": "Blocked",
  "error.SMS_NOT_CONFIGURED": "No SMS account connected.",
  "error.SMS_AUTH": "Wrong SMS username or API password.",
  "error.SMS_BAD_SENDER": "The sender name is not approved, or your account has no approved sender name yet. Apply for one in your provider's panel; it can be used once approved.",
  "error.SMS_PASSWORD_REQUIRED": "API password required.",
  "error.SMS_NO_CREDIT": "Not enough SMS credit.",
  "error.SMS_TOO_LONG": "Message too long.",
  "error.SMS_EMPTY": "Message is empty.",
  "error.SMS_RATE_LIMIT": "The provider is busy; try again shortly.",
  "error.SMS_NUMBER_DAILY_LIMIT": "Daily SMS limit for this number reached.",
  "error.SMS_CALL_LIMIT": "SMS limit for this call reached.",
  "error.SMS_DAILY_LIMIT": "Today's SMS limit reached.",
  "error.SMS_PROVIDER_ERROR": "The SMS provider refused the request.",
  "error.SMS_PROVIDER_DOWN": "Could not reach the SMS provider.",
  "wa.title": "WhatsApp",
  "wa.hint": "Messages the agent sends from a call (summary, link) go from your business's own WhatsApp Business account, using templates approved by Meta. Only to the number on the call, when the customer asks.",
  "wa.none": "No WhatsApp account connected.",
  "wa.connect": "Connect WhatsApp",
  "wa.where": "Find these in Meta for Developers → your app → WhatsApp → API Setup.",
  "wa.phoneNumberId": "Phone number ID",
  "wa.phoneNumberId.hint": "Digits only.",
  "wa.wabaId": "WhatsApp Business Account ID",
  "wa.wabaId.hint": "Digits only.",
  "wa.token": "Access token",
  "wa.token.hint": "For a permanent token: Meta Business Settings → System users. A temporary token expires in 24 hours.",
  "wa.language": "Language",
  "wa.language.hint": "Default template language, e.g. tr, en, ar.",
  "wa.saved": "WhatsApp account verified and saved.",
  "wa.removed": "WhatsApp account removed.",
  "wa.templates.count": "{n} approved templates ({all} in total)",
  "wa.templates.unknown": "Templates could not be loaded right now.",
  "wa.template": "Template",
  "wa.category": "Category",
  "wa.template.none": "No approved template; add one in WhatsApp Manager → Message templates.",
  "wa.params": "Values",
  "wa.params.hint": "For {{1}}, {{2}}… in order, separated by |. Empty for a template without variables.",
  "wa.test": "Test message",
  "wa.test.to.hint": "With the test number, only recipients registered at Meta (up to 5) receive it.",
  "wa.test.sent": "WhatsApp message sent.",
  "error.WHATSAPP_NOT_CONFIGURED": "No WhatsApp account connected.",
  "error.WA_AUTH": "The access token is invalid or expired.",
  "error.WA_BAD_ID": "IDs must be digits only.",
  "error.WA_TOKEN_REQUIRED": "Access token required.",
  "error.WA_RECIPIENT_NOT_ALLOWED": "This number is not on the test number's recipient list (Meta → API Setup → \"To\").",
  "error.WA_TEMPLATE_UNKNOWN": "Template not found.",
  "error.WA_TEMPLATE_NOT_APPROVED": "The template is not approved in this language.",
  "error.WA_TEMPLATE_PARAMS": "Template values missing or too many.",
  "error.WA_WINDOW_CLOSED": "Free text only within 24 hours of the customer's last message; use a template.",
  "error.WA_UNDELIVERABLE": "Could not deliver to this number (it may not use WhatsApp).",
  "error.WA_RATE_LIMIT": "WhatsApp sending limit reached; try again shortly.",
  "error.WA_PROVIDER_ERROR": "Meta refused the request.",
  "error.WA_PROVIDER_DOWN": "Could not reach Meta.",
  "wa.host.none": "No WhatsApp number connected in Panaryus. Connect it once in Panaryus; the agent sends from it and customer replies land in the Panaryus inbox.",
  "wa.host.connect": "Connect WhatsApp in Panaryus",
  "wa.host.manage": "Manage in Panaryus",
  "wa.host.managed": "Number connected in Panaryus — replies arrive in the Panaryus inbox.",
  "error.WA_HOST_UNREACHABLE": "Could not reach Panaryus.",
  "error.WHATSAPP_MANAGED_BY_HOST": "WhatsApp is managed in Panaryus.",
  "error.PRINCIPAL_NOT_FOUND": "Panaryus account not found.",
  "compliance.title": "Required disclosures",
  "compliance.item.ai_disclosure": "Said it is an AI",
  "compliance.item.recording_notice": "Gave the recording notice",
  "compliance.item.business_identity": "Said the registered business name",
  "compliance.late": "later than required",
  "compliance.missing": "not said",
  "error.PERMISSION_DENIED": "You do not have permission for this. Ask the team owner or a manager.",
  "error.NOT_A_MEMBER": "You do not have access to this workspace.",
  "error.ACCESS_UNAVAILABLE": "Your permissions could not be checked right now; try again shortly.",
  "error.ROUTE_NOT_CLASSIFIED": "This action is currently disabled.",
  "error.VOICE_TURKISH_ONLY": "This voice speaks Turkish only; this agent's language is different.",
  "access.readOnly": "View only. Changing this needs the “{name}” permission. Ask the team owner or a manager.",
  "access.noPage": "You do not have access to this page. It needs the “{name}” permission. Ask the team owner or a manager.",
  "access.perm.centeros.view": "See calls and statistics",
  "access.perm.centeros.recordings": "Recordings and full transcripts",
  "access.perm.centeros.call": "Calls and the test room",
  "access.perm.centeros.contacts": "Contacts and the do-not-call list",
  "access.perm.centeros.campaigns": "Campaigns",
  "access.perm.centeros.agents": "Agents (create, edit, publish)",
  "access.perm.centeros.lines": "Phone lines and messaging",
  "access.perm.centeros.compliance": "Privacy and the activity log",
  "nav.audit": "Activity log",
  "audit.title": "Activity log",
  "audit.subtitle": "Who did what and when in the panel: changes, recordings listened to and refused attempts. No content is stored; entries cannot be deleted.",
  "audit.empty": "No entries yet.",
  "audit.when": "Time",
  "audit.who": "Who",
  "audit.what": "Action",
  "audit.on": "Target",
  "audit.result": "Result",
  "audit.more": "Older",
  "audit.res.ok": "Done",
  "audit.res.denied": "Not allowed",
  "audit.res.failed": "Error",
  "audit.verb.POST": "add/action",
  "audit.verb.PUT": "change",
  "audit.verb.PATCH": "change",
  "audit.verb.DELETE": "delete",
  "audit.verb.GET": "view",
  "audit.area.agents": "Agent",
  "audit.area.calls": "Call",
  "audit.area.contacts": "Contacts",
  "audit.area.do-not-call": "Do-not-call",
  "audit.area.campaigns": "Campaign",
  "audit.area.telephony": "Phone line",
  "audit.area.sms": "SMS account",
  "audit.area.whatsapp": "WhatsApp",
  "audit.area.templates": "Template",
  "audit.area.studio": "Studio",
  "audit.area.test-rooms": "Test room",
  "audit.area.previews": "Preview",
  "audit.action.POST /v2/api/agents/:id/publish": "Agent published",
  "audit.action.PUT /v2/api/agents/:id/spec": "Agent settings changed",
  "audit.action.POST /v2/api/agents/:id/calls": "Call started",
  "audit.action.POST /v2/api/agents/:id/web-calls": "Browser call",
  "audit.action.GET /v2/api/calls/:id/recording": "Recording listened to",
  "audit.action.POST /v2/api/do-not-call": "Added to do-not-call",
  "audit.action.DELETE /v2/api/do-not-call/:e164": "Removed from do-not-call",
  "audit.action.POST /v2/api/contacts/import": "Contacts imported",
  "audit.action.DELETE /v2/api/contacts/:id": "Contact deleted",
  "audit.action.POST /v2/api/campaigns": "Campaign created",
  "audit.action.POST /v2/api/campaigns/:id/:action": "Campaign started/stopped",
  "audit.action.POST /v2/api/test-rooms": "Test room call",
  "nav.privacy": "Data & privacy",
  "privacy.title": "Data & privacy",
  "privacy.subtitle": "How long the personal data of calls is kept. What is due is deleted automatically every night.",
  "privacy.retention": "Retention",
  "privacy.retention.hint": "Each {min}–{max} days. Personal data should not be kept longer than needed; set these with your legal adviser.",
  "privacy.recordings": "Call recordings (days)",
  "privacy.recordings.hint": "Recommended: {n} days. A due recording is deleted from storage.",
  "privacy.transcripts": "Transcripts and summaries (days)",
  "privacy.transcripts.hint": "Recommended: {n} days. Transcript, summary, collected facts and the customer's words are deleted.",
  "privacy.messages": "Sent messages (days)",
  "privacy.messages.hint": "Recommended: {n} days. SMS/WhatsApp texts are deleted.",
  "privacy.kept": "Kept: the call's date and length, score, outcome, the moments of the disclosures and the cost — statistics keep working. The do-not-call list is not deleted.",
  "privacy.save": "Save",
  "privacy.saved": "Retention saved.",
  "privacy.updated": "Last changed: {at}",
  "privacy.usingDefaults": "Using the recommended periods.",
  "privacy.callPurged": "This call's recording and/or transcript was deleted on {at} (retention).",
  "privacy.erase.title": "Personal data deletion request",
  "privacy.erase.hint": "When a person asks for their data to be deleted: recordings of that number are deleted; transcripts, summaries, messages and the name/number in campaign lists are erased; the contact is removed. Limited to this workspace.",
  "privacy.erase.phone": "Phone number",
  "privacy.erase.dnc": "Add to the do-not-call list so they are never called again (only the number is kept)",
  "privacy.erase.button": "Delete the data permanently",
  "privacy.erase.warn": "Cannot be undone. Written to the activity log.",
  "privacy.erase.done": "Deleted: {calls} calls, {recordings} recordings, {messages} messages, {contacts} contacts.",
  "privacy.iys.title": "Consent registry check (İYS)",
  "privacy.iys.hint": "Before a commercial call the number's consent is asked from İYS (Türkiye's consent registry). The answer is kept for a few days; during that time the same number is not queried again. A number without consent is not called (the campaign report says \"No consent in İYS\"). When a person says \"do not call me\", their kept answer stops counting. Informational agents are not checked.",
  "privacy.iys.enabled": "Ask İYS for consent before a commercial call",
  "privacy.iys.days": "Keep the answer for (days)",
  "privacy.iys.days.hint": "0–30 days, 7 recommended. 0 = asked again on every call.",
  "privacy.iys.skipBusiness": "Skip the İYS query for numbers marked \"business\" in contacts",
  "privacy.iys.skipBusiness.hint": "This rule is based on general information and awaits a lawyer's confirmation, so it can be turned off. When off, business numbers are queried too (as merchants). Numbers marked \"unknown\" are queried like a person's.",
  "privacy.iys.noProvider": "No İYS provider is connected yet, so the check cannot be turned on. Once connected, one query costs {price} TRY.",
  "privacy.iys.mock": "A trial provider is connected: answers are made up and free; İYS is not asked.",
  "privacy.iys.provider": "Provider: {name} · {price} TRY per query",
  "privacy.iys.stats": "This month ({month})",
  "privacy.iys.stats.queries": "Queries sent",
  "privacy.iys.stats.cached": "Answered from a kept answer",
  "privacy.iys.stats.business": "Business numbers (no query)",
  "privacy.iys.stats.spent": "Spent",
  "privacy.iys.money": "{amount} TRY",
  "privacy.iys.defaults": "Default settings: check off, 7 days, skip business numbers.",
  "privacy.iys.saved": "İYS settings saved.",
  "settings.legal": "Legal details",
  "settings.legal.hint": "Who is calling and why, for commercial calls.",
  "field.identity.legalName": "Registered business name",
  "field.identity.legalName.hint": "When set, the agent must say it in the opening; the call card shows the evidence.",
  "field.callPurpose": "Purpose of calls",
  "field.callPurpose.hint": "For commercial calls the consent registry is checked before dialling when connected.",
  "field.callPurpose.commercial": "Commercial (promotion, sales)",
  "field.callPurpose.informational": "Informational (appointment, reminder, transaction)",
  "settings.consent.notConnected": "The consent registry is not connected yet: commercial calls are not checked. Verify consent yourself before calling individuals for commercial purposes.",
  "error.CONSENT_REFUSED": "This number does not consent to commercial calls.",
  "error.CONSENT_UNKNOWN": "This number's consent is unknown; not called per the settings.",
  "error.IYS_NO_CONSENT": "No consent in İYS",
  "error.IYS_PROVIDER_MISSING": "No İYS provider is connected.",
  "error.IYS_CHECK_FAILED": "The İYS query could not be made.",
  "error.BACKUP_VOICE_UNKNOWN": "This backup voice is not offered; pick one from the list.",
  "error.CALL_HAS_NO_NUMBER": "This call has no phone number to save.",
  "error.HOURS_INVALID": "The opening hours are not valid.",
  "error.INBOUND_AGENT_REQUIRED": "First choose the agent that answers this number.",
  "error.CLOSED_MESSAGE_FAILED": "The message could not be voiced; save again in a moment.",
  "calls.tab.web": "Website chats",
  "web.empty": "No website chats yet. Once the kit is on your site, visitor chats appear here.",
  "web.pick": "Pick a chat.",
  "web.messages": "{n} messages",
  "web.collected": "What the agent collected",
  "web.request": "Topic passed to the team",
  "web.page": "Last page",
  "web.ended": "Ended",
  "web.open": "Open",
  "web.visitor": "Visitor",
  "web.agent": "Agent",
  "web.noFacts": "Nothing collected yet.",
  "web.site": "Site",
  "calls.party.webChat": "Website chat",
  "web.report": "Conversation report",
  "web.report.none": "This chat started before reports existed; it has none.",
  "web.report.pending": "The report is being prepared (within a minute after the chat ended).",
  "web.report.afterEnd": "The report is prepared when the chat ends (the visitor ends it or after 2 idle hours).",
  "web.openCall": "Open the conversation card (cost, evaluation)"
}
